<template>
  <div :id="chartName" style="width: 100%; height: 100%"></div>
</template>

<script>
import echarts from "echarts";

// import { get } from '@/utils/request';
import Log from "@/utils/log";
import chartType from "./types";

// 临时添加get方法，后续统一到request中
function get(url) {
  return fetch(url).then((res) => res.json());
}

const log = Log("cschart");
export default {
  name: "CsChart",
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    datas: {
      // {name, value}, 如果legend存在，则value是一个对象{[name]:value}
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      chartName: `chart_${Math.random()}`.replace("0.", ""),
      chart: null,
    };
  },
  mounted() {
    this.chart = this.getChart();
    if (this.datas) {
      setTimeout(() => this.refresh(), 100);
    }
  },
  methods: {
    getChart() {
      const dom = document.getElementById(this.chartName);
      return echarts.init(dom);
    },
    getCharData() {
      get(this.config.api).then(() => this.refresh());
    },
    getConfig() {
      return {
        title: "",
        type: "line", // line, bar, pie,
        xAxis: [], // {name, label}, optional
        ...this.config,
      };
    },
    refresh() {
      const config = this.getConfig();
      var option = chartType.getOption(config, this.datas);
      log.debug("refresh chart:", option);
      this.chart.setOption({ ...option, width: "100%", height: "100%" });
    },
  },
};
</script>
